'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DefinitionTable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BodyText = require('../typography/BodyText');

var _BodyText2 = _interopRequireDefault(_BodyText);

var _Card = require('../card/Card');

var _Card2 = _interopRequireDefault(_Card);

var _Label = require('../typography/Label');

var _Label2 = _interopRequireDefault(_Label);

require('./definitionTable.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function DefinitionTable(props) {
  var title = props.title,
      data = props.data,
      outsideTitle = props.outsideTitle;
  var definitionList = data.map(function (list) {
    return _react2.default.createElement('div', {
      className: 'definition-row'
    }, _react2.default.createElement('span', {
      className: 'definition-name definition-cell'
    }, _react2.default.createElement(_Label2.default, {
      label: list[Object.keys(list)[0]]
    })), _react2.default.createElement('span', {
      className: 'definition-defined definition-cell'
    }, _react2.default.createElement(_BodyText2.default, null, ' ', list[Object.keys(list)[1]])));
  });
  return _react2.default.createElement(_Card2.default, {
    customClass: 'reportsCard',
    title: title,
    outsideTitle: outsideTitle
  }, _react2.default.createElement('div', {
    className: 'definitions-table'
  }, definitionList));
}

DefinitionTable.propTypes = {
  title: _propTypes2.default.string,
  outsideTitle: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    term: _propTypes2.default.string.isRequired,
    definition: _propTypes2.default.string.isRequired
  }).isRequired
};
DefinitionTable.defaultProps = {
  title: '',
  outsideTitle: false
};